import createIcon from '../../createIcon';

/**
 * @component @name ChecklistRtl
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgNy41MzQ4NEgyVjkuNTM0ODRIMTFWNy41MzQ4NFpNMTEgMTUuNTM0OEgyVjE3LjUzNDhIMTFWMTUuNTM0OFpNMTYuMzQgMTEuNTM0OEwxMi44IDcuOTk0ODRMMTQuMjEgNi41ODQ4NEwxNi4zMyA4LjcwNDg0TDIwLjU3IDQuNDY0ODRMMjIgNS44NzQ4NEwxNi4zNCAxMS41MzQ4Wk0xNi4zNCAxOS41MzQ4TDEyLjggMTUuOTk0OEwxNC4yMSAxNC41ODQ4TDE2LjMzIDE2LjcwNDhMMjAuNTcgMTIuNDY0OEwyMiAxMy44NzQ4TDE2LjM0IDE5LjUzNDhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChecklistRtl = createIcon('ChecklistRtl', [
  [
    'path',
    {
      d: 'M11 7.53484H2V9.53484H11V7.53484ZM11 15.5348H2V17.5348H11V15.5348ZM16.34 11.5348L12.8 7.99484L14.21 6.58484L16.33 8.70484L20.57 4.46484L22 5.87484L16.34 11.5348ZM16.34 19.5348L12.8 15.9948L14.21 14.5848L16.33 16.7048L20.57 12.4648L22 13.8748L16.34 19.5348Z',
      key: '1se0uw',
    },
  ],
]);

export default ChecklistRtl;
